import React, { useState } from "react";
import { IActionHandler, AdminUserBase } from "@preveil-api";
import { useAppDispatch, useAppSelector, isSameUser } from "src/common";
import { ListView, Toolbar } from ".";
import { adminActions } from "src/store";
import { RootState } from "src/store/configureStore";
import _ from "lodash";

type AllProps = {
    org_users: AdminUserBase[];
    refetchUsersShardStatuses: () => void;
    is_loading: boolean;
}

// Description: This component is used to render the list of users in the data export get started page
function UsersCollapseComponent(props: AllProps) {
    const { org_users, refetchUsersShardStatuses, is_loading } = props;
    const dispatch = useAppDispatch();
    const selected = useAppSelector((state: RootState) => state.admin.selected);
    const users_with_export_shards = useAppSelector((state: RootState) => state.admin.users_with_export_shards);
    const [filter_param, setFilterParam] = useState<string>("");
    const [filtered_list, setFilteredList] = useState<AdminUserBase[]>(org_users);

    const UsersCollapseRequest = {
        handleSelect: (params: { user?: AdminUserBase, selected: boolean; }) => {
            let new_selected = selected.slice();
            const _id = !!params.user ? params.user.user_id : null;
            if (!!_id) { // Note: individual check
                if (params.selected) {
                    !_.find(new_selected, (_selected: string) => (isSameUser(_selected, _id))) &&
                        new_selected.push(_id);
                } else {
                    const index = _.findIndex(new_selected, (_selected: string) => (isSameUser(_selected, _id)));
                    index >= 0 && (new_selected.splice(index, 1));
                }
            } else {
                // Note: user_ids from org_users can include addresses with mixed case/uppercase ids (from backend)
                new_selected = params.selected
                    ? org_users.filter((u: AdminUserBase) => users_with_export_shards.some((id: string) => isSameUser(id, u.user_id))).map((u: AdminUserBase) => u.user_id)
                    : [];
            }
            dispatch(adminActions.setSelected(new_selected));
        },
        handleSearchParam: (param?: string) => {
            if (!!param) {
                setFilterParam(param.toLowerCase());
                const filtered = org_users.filter((user: AdminUserBase) => {
                    return Object.values(user).some(field =>
                        _.isString(field) && field.toLowerCase().includes(param.toLowerCase())
                    );
                });
                setFilteredList(filtered);
            } else {
                setFilterParam("");
                setFilteredList(org_users);
            }
        },
    };

    function handlePageActions(action_obj: IActionHandler) {
        const callback = `handle${action_obj.actionType}`;
        if ((UsersCollapseRequest as any)[callback] instanceof Function) {
            (UsersCollapseRequest as any)[callback](action_obj.params);
        }
    }
    
    return (
      <div className="admin-component max-700 pb-0">
        <Toolbar
          users_list_length={org_users.length}
          filtered_length={filtered_list.length}
          filter_param={filter_param}
          handleAction={handlePageActions}
          refetchUsersShardStatuses={refetchUsersShardStatuses}
        />
        <div id="outer-scope" className="cover-content">
          <ListView users_list={filtered_list} handleAction={handlePageActions} is_loading={is_loading} />
        </div>
      </div>
    );
}

export default React.memo(UsersCollapseComponent);